import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { Device } from '@ionic-native/device';
import {LoginPage} from '../login/login';
import {DeliveryPage} from "../delivery/delivery";
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import {MyvariableService} from '../home/constantvariable';
import {ProductviewPage} from '../productview/productview';
import {KiloMenuPage} from "../kilomenu/kilomenu";
import {KiloPartyPage} from "../kiloparty/kiloparty";
import {KiloStorePage} from "../kilostore/kilostore";
@Component({
	selector: 'page-mycart',
	templateUrl: 'mycart.html',
	providers:[MydataService,MyUrlService,JsonData,Device,MyvariableService]	
})

export class MycartPage implements OnInit {
	myDate: String = new Date().toISOString();
	////Time= new Date().toISOString()
	jsonDt : Array<JsonData>;
	addtocartDt: Array<JsonData>;
	totalAmountDt:string;
	noofitem :string;
	amount :string;
	msgDt:string;
	local:string;
	deleDt:string;
	sendContinueData:string;
	varDiscount:any;
	showTotalAmt:any;
	finalTotalAmt:any;
	myParseInt = parseInt;
	pcs = this.MyvariableService.PCS;
	itemPerPack = this.MyvariableService.ITEMPARPACK;
	tax = this.MyvariableService.TAX;
	discountAmountDt:string;
	userid:string;
	event = {
		month: new Date().toISOString(),
		timeStarts: '07:43',
		//timeEnds: '2190-02-20'
	}
	
	constructor(public device: Device,public loading: LoadingController,private http:Http,public navCtrl: NavController,private mydataService: MydataService,private myurlService: MyUrlService,public alerCtrl: AlertController,private MyvariableService: MyvariableService) {
	}
	
    ngOnInit(){
		this.mydataService.navigationRef();
		this.kiloPointCheck();
		
	}
	kilomenu(cartid)
	{
		window.localStorage.setItem('localid', cartid );
		//window.localStorage.setItem('subcatid', subcat );
		//var xyz = window.localStorage.getItem('localid');
		
		//alert(cartid)
		if(cartid==1)
		{
			//this.navCtrl.push(KiloMenuPage);
			this.navCtrl.setRoot(KiloMenuPage);
		}
		if(cartid==2)
		{
			//this.navCtrl.push(KiloPartyPage);
			this.navCtrl.setRoot(KiloPartyPage);
		}
		if(cartid==3)
		{
			//this.navCtrl.push(KiloStorePage);
			this.navCtrl.setRoot(KiloStorePage);
		}
		
	}
		kiloPointCheck=function(){
			var userid = window.localStorage.getItem('userid');
		var kiloSabjiJSONdata = JSON.stringify({"usediscount":"1","userid":userid,"IMEI":window.localStorage.getItem('session_ids'),"deliverytype":"Doorstep Delivery"});
		//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
		
		let loader = this.loading.create({content: '',});
		loader.present().then(() => {
			this.mydataService.postJSON(this.myurlService.MYCARTCHECKOUTCAll ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.SendDataOnS(loader));
		});
	}
	SendDataOnS=function(loader){
	//console.log("aaaaaaaaaa"+JSON.stringify(this.jsonDt));
	this.addcartService();
	loader.dismiss();
	}
	
	addcartService=function(){
	if(this.mydataService.checkInternetFunction()=="0"){
	////console.log("Internet UnAvailable")
	}else  if(this.mydataService.checkInternetFunction()=="1"){
	let loader = this.loading.create({content: '',});
	////console.log('Device UUID is: ' + this.device.uuid);
	//alert("hello IMEI--->"+this.device.uuid);
	var session_ids=window.localStorage.getItem('session_ids');
	var kiloSabjiJSONdata = JSON.stringify({"IMEI":session_ids,"userid":window.localStorage.getItem('userid')});
	
	//	//console.log("Product Url--->"+this.myurlService.MYCARTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.MYCARTURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.myCartService(loader));
	});			
	}}
	myCartService=function(loader){
		//console.log("addtocartdata receive jsondata ==>"+JSON.stringify(this.jsonDt));
		//alert("addtocartdata receive jsondata ==>"+JSON.stringify(this.jsonDt));
		//window.plugins.paytm.startPayment("526", "25862", "abc@gmail.com", "777777777", "25", successCallback, failureCallback);
		var sendData=null;
		this.addtocartDt = this.jsonDt.addtocartdata;
		
		this.totalAmountDt = this.jsonDt.totalAmount;
		this.discountAmountDt = this.jsonDt.discountAmount;
		this.deliverydatedataDt = this.jsonDt.deliverydatedata;
		this.image= this.myurlService.IMAGEURL;
		loader.dismiss();
		if(this.addtocartDt.length>0){
		this.cartid = this.addtocartDt[0].cartid;}
		this.amount = this.totalAmountDt[0].amount;
		this.noofitem = this.addtocartDt.length;
		this.description = window.localStorage.getItem('description_kilomenus');
	   this.descriptiones = window.localStorage.getItem('description_kilopartys');
	    this.descriptions = window.localStorage.getItem('description_kilostores');
		//this.totalSendAmt = this.totalAmountDt[0].amount;addtocartdetail
	
	this.addtocartDetailDt = this.jsonDt.addtocartdetail;
	
	//alert(JSON.stringify(this.addtocartDt));
	for(var i=0;i<this.addtocartDt.length;i++){
	this.cartid = this.addtocartDt[i].cartid;
	var dataArray=null;
	////console.log("aaaaaaaaaasdfssssfffffloop===>"+this.cartid+"<=================>"+this.addtocartDetailDt[i].addtocartId);
	
	if(this.addtocartDetailDt.length>0){
	for(var j=0;j<this.addtocartDetailDt.length;j++){
	////console.log(j+"<======aaffloop===>"+this.cartid+"<=================>"+this.addtocartDetailDt[j].addtocartId);
	
	if(this.cartid == this.addtocartDetailDt[j].addtocartId){
	////console.log("aaaaaaaaaaaa=out==>"+dataArray+j)
	if(dataArray==null){
	//	//console.log("aaaaaaaaaaaa=In==>"+dataArray+j)
	dataArray = JSON.stringify(this.addtocartDetailDt[j]);
	
	//			//console.log("jdakjklsjglkjsljk-this.addtocartDetailDt[j]===>====>"+this.addtocartDetailDt[j]+" dataArray==>hhhhhhhhhhhhhhhhhh==========>"+dataArray);
	}else{
	//				//console.log("aaaaaaaaaaaa=else==>"+dataArray+j)
	dataArray = JSON.stringify(this.addtocartDetailDt[j])+","+dataArray;
	}
	//	//console.log("ssssssssssss==this.addtocartDt[i])+JSON.stringify(this.addtocartDetailDt[j]=>"+JSON.stringify(this.addtocartDt[i])+JSON.stringify(this.addtocartDetailDt[j]));
	
	}else{
	if(dataArray==null){
	dataArray =JSON.stringify({"addtocartI":'',"productId":'',"categoryid":''});
	}}
	}}else
	{	dataArray =JSON.stringify({"addtocartId":'',"productId":'',"categoryid":''});
	}
	dataArray = "["+dataArray+"]";
	//	//console.log("ffffffffffffffffffffffffffffffffffffff===>"+dataArray);
	//"discount":"8","taxableamt":"92.00","SGSTtaxamt":"5.52","CGSTtaxamt":"5.52","billamt":"103.04"
	var kiloSabjiJSONdata = JSON.stringify({"categoryname":this.addtocartDt[i].categoryname,"productName":this.addtocartDt[i].productName,"type":this.addtocartDt[i].type,"qty":this.addtocartDt[i].qty,"price":this.addtocartDt[i].price,"totalAmount":this.addtocartDt[i].totalAmount,"productId":this.addtocartDt[i].productId,"categoryid":this.addtocartDt[i].categoryid,"uom":this.addtocartDt[i].uom,"uomid":this.addtocartDt[i].uomid,"cartid":this.addtocartDt[i].cartid,"orderqty":this.addtocartDt[i].orderqty,"qtyPerPack":this.addtocartDt[i].qtyPerPack,"qtys":this.addtocartDt[i].qtys,"balqty":this.addtocartDt[i].balqty,"taxableamt":this.addtocartDt[i].taxableamt,"SGSTtaxamt":this.addtocartDt[i].SGSTtaxamt,"CGSTtaxamt":this.addtocartDt[i].CGSTtaxamt,"billamt":this.addtocartDt[i].billamt,"discount":this.addtocartDt[i].discount,"kilopartyorder":JSON.parse(dataArray)});
	dataArray=null;
	if(this.sendContinueData ==null){
	this.sendContinueData = kiloSabjiJSONdata;
	}else{
	this.sendContinueData =kiloSabjiJSONdata+","+this.sendContinueData;
	}
	}
	this.sendContinueData = "["+this.sendContinueData+"]";
	//		//console.log("send Json Data To Server===>"+this.sendContinueData);		
	
	this.showTotalAmt=0.0;
	this.varDiscount=0.0;
	for(var j=0;j<this.addtocartDt.length;j++){
	////console.log("ssssssssssssaddsd"+this.addtocartDt[j].discount);
	this.varDiscount = parseInt(this.addtocartDt[j].discount) + parseInt(this.varDiscount);

	this.showTotalAmt = parseFloat(this.showTotalAmt)+(parseFloat(this.addtocartDt[j].totalAmount));
	}
	//alert("Discount===>"+this.varDiscount)
	this.userid = window.localStorage.getItem('userid');
	//alert("this.userid===>"+this.userid)
	if(this.userid!=null){
	this.finalTotalAmt = this.showTotalAmt - this.varDiscount;
	}else{
	this.finalTotalAmt=this.showTotalAmt;
	}
	
	var givenpoint = this.discountAmountDt[0].givenpoint;
	var useddiscount = this.discountAmountDt[0].useddiscount;
	////console.log("deliverydatedataDt receive jsondata ==>"+JSON.stringify(this.jsonDt.deliverydatedata));
	window .localStorage.setItem('noofitem',this.noofitem);
	window.localStorage.setItem('totalAmount',this.amount);
	window.localStorage.setItem('useddiscount',useddiscount);
	window.localStorage.setItem('givenpoint',givenpoint);
	
	}
	KiloPointService = function(){
	//alert(this.jsonDt);
	}
	errorFunction= function(loader,error){
	loader.dismiss();
	//console.log(error);
	//alert(error);
	}
	continue(delDate,delTime){
	//alert("delDate==>"+delDate+"    delDate==."+delDate);
	if(delDate!='' &&delTime!=''){
	
	var multtti =JSON.stringify(this.addtocartDt)
	//window.localStorage.setItem('multiple',this.sendContinueData);
	//window.localStorage.setItem('multiple',multtti);
	
	window.localStorage.setItem('chekout','1');
	window.localStorage.setItem('delDate',delDate);
	window.localStorage.setItem('delTime',delTime);
	window.localStorage.setItem('showTotalAmt',this.finalTotalAmt);
	var userid=window.localStorage.getItem('userid');
	if(userid != null)
	{
	//alert('user login')
	this.checkProductAvail();

	}
	else
	{
	//alert("user not login");
	this.navCtrl.push(LoginPage);
	}
	}else{
	//alert('Please Select Delivery date And Time');
	this.showAlert(this.MyvariableService.MYCARTTIME);
	}
	}
	checkProductAvail=function(){
		var kiloSabjiJSONdata = JSON.stringify({"deliverydate":window.localStorage.getItem('delDate'),"userid":window.localStorage.getItem('userid'),"IMEI":window.localStorage.getItem('session_ids')});
			//alert(this.myurlService.MYCARTCHECKOUTCAll +"           "+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.CHECKPRODUCTEXIST ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.AvailProduct(loader));
			});
		}
		
		AvailProduct=function(load){
				load.dismiss();
				//alert("chekk===>"+JSON.stringify(this.jsonDt))
				//alert("chekk msg===>"+JSON.stringify(this.jsonDt.msg))
				//alert("chekk===>"+JSON.stringify(this.jsonDt))
				if(this.jsonDt.msg==""){
					this.navCtrl.push(DeliveryPage);
					}else{
						this.showAlert(this.jsonDt.msg);
					}
					
		}
	
	showAlert=function(subTitlee) {
	
	let alert = this.alerCtrl.create({
	// title: 'New Friend!',
	subTitle: subTitlee,
	buttons: [ {
	text: 'Ok'
	}
	]
	
	});
	
	alert.present();
	}
	orderQtyFun(miniQty , maxQty, orderQty , checkstatus,cartid,qty,price,parent_id){
	
	//console.log('myFunction===>'+miniQty+"   "+maxQty +"   " +orderQty+"   "+checkstatus+cartid+qty+price+"                 parent_id===>"+parent_id);
	//alert('myFunction===>'+miniQty+"   "+maxQty +"   " +orderQty+"   "+checkstatus+"   "+cartid+"  "+qty+"  "+price);
	if(checkstatus=='subitemm') {
	if (orderQty < 1) { //console.log('min qty false');
	return 1;
	} else { //console.log('min qty true');
	
	this.updateequty(cartid,orderQty,price*orderQty);
	
	return orderQty;
	}
	}else if(checkstatus=='addditem') {
	//alert(window.localStorage.getItem('localid'));
	if(parent_id!="1"){
			//console.log('parent Id is not 1');
	if (orderQty > maxQty) { //console.log('min qty false');
	
	return maxQty;
	}
	else { //console.log('min qty true');
	this.updateequty(cartid,orderQty,price*orderQty);
	return orderQty;
	}
	}
		if(parent_id=="1"){
		//console.log('parent Id 1');
			this.updateequty(cartid,orderQty,price*orderQty);
	return orderQty;
		}
	}
	}
	
	updateequty=function(cartid,qty,price)
	{
	//alert('update '+cartid+"   "+qty+"    "+price);
	var kiloSabjiJSONdata = JSON.stringify({"cartid":cartid,"quty":qty,"totalAmount":price});
	
	//console.log("Product Url--->"+this.myurlService.UPDATEORDERURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	let loader = this.loading.create({content: '',});
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.UPDATEORDERURL ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.updatequtys(loader));
	});
	}
	updatequtys=function(loader){
	this.msgDt = this.jsonDt.msg;
	//console.log("msg receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
	this.addcartService();
	loader.dismiss();
	}
	
	doConfirm(cartid) {
	let confirm = this.alerCtrl.create({
	title: 'Use this lightsaber?',
	message: 'Do you agree to use this lightsaber to do good across the intergalactic galaxy?',
	buttons: [
	{
	text: 'Cancel',
	handler: () => {
	//console.log('Disagree clicked');
	}
	},
	{
	text: 'Ok',
	handler: () => {
	//alert(cartid);
	}
	
	}
	
	]
	});
	confirm.present()
	}
	
	
	remove(cartid,productid)
	{
	var session_ids=window.localStorage.getItem('session_ids');
	//alert(productid);
	var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"cartid":cartid,"productid":productid,"IMEI":session_ids});
	//console.log("Product Url--->"+this.myurlService.DELETORDER+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	let loader = this.loading.create({content: '',});
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.DELETORDER ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.deletepro(loader));
	});
	}
	
	deletepro=function(loader){
	
	this.msgDt = this.jsonDt.msg;
	//console.log("msg receive jsondata ==>"+JSON.stringify(this.jsonDt.msg));
	loader.dismiss();
	this.addcartService();
	}
	
	productview(cartid,viewType)
	{
	window.localStorage.setItem('cartid',cartid);
	window.localStorage.setItem('viewType',viewType);
	//alert("my cart"+viewType)
	this.navCtrl.push(ProductviewPage);
	}
	
	datalist()
	{
	let deliverydate = this.local;
	//alert(deliverydate);
	var session_ids=window.localStorage.getItem('session_ids');
	var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"deliverydate":deliverydate,"IMEI":session_ids});
	//console.log("Product Url--->"+this.myurlService.DELIVERYDATE+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
	let loader = this.loading.create({content: '',});
	loader.present().then(() => {
	this.mydataService.postJSON(this.myurlService.DELIVERYDATE ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.dateDataService(loader));
	});
	}
	
	dateDataService=function(loader){
	//alert(JSON.stringify(this.jsonDt))
	this.deliverydateDt = this.jsonDt.DeliveryTime;
	loader.dismiss();
	//console.log("time===>"+JSON.stringify(this.jsonDt));
	if(this.deliverydateDt==''){
	this.showTimeAlert();
	}
	////console.log("deliverydate receive jsondata ==>"+JSON.stringify(this.jsonDt.DeliveryTime));
	
	}
	showTimeAlert=function() {
	
	let alert = this.alerCtrl.create({
	// title: 'New Friend!',
	subTitle: 'This order is not available for this date.',
	buttons: ['OK']
	});
	alert.present();
	}
	
	}
	
		


// WEBPACK FOOTER //
// ./src/pages/mycart/mycart.ts